import { TEXT } from "../configs/text"
import { AssessmentAnswer } from "./assessment"
import { Session, RewardPoint } from "./session"

export interface ClassItemProps {
    id: number
    name: string
    start_date: number
    end_date: number
    start_time: string
    end_time: string
    state: ClassStatus
    topic?: string | null
    subject_name?: string | null
    unit_name?: string | null
    lesson_name?: string | null
    system: string
}

export interface ClassSection {
    course_item_id: number | null
    custom_section_desc: string | null
    custom_section_name: string | null
    is_active: number
    section_code: string | null
}

export interface ClassDetails extends ClassItemProps {
    access_code: string
    teacher_name: string
    assistant_name: string | null
    groups: ClassGroupInfo[]
    students?: ClassStudentInfo[]
    student_group_id?: number | null
    lockScreen?: boolean
    allowRaiseHand?: boolean
    expiredTime?: number
    grade: number
    sections: ClassSection[]
    bonus_point: RewardPoint[]
    desc: ClassType
}

export enum ClassType {
    iclass = 'iclass',
    igen = 'igen',
}

export enum ClassStatus {
    not_started = 'not_started',
    on_going = 'on_going',
    finished = 'finished',
}

export enum ClassRequestStatus {
    rejected = 0,
    approved = 1
}

export const classStatusMap = {
    [ClassStatus.not_started]: TEXT.not_started,
    [ClassStatus.on_going]: TEXT.on_going,
    [ClassStatus.finished]: TEXT.finished,
}

export interface ClassGroupInfo {
    id: number
    name: string
    students: ClassStudentInfo[] | null
    bonus_point?: RewardPoint[]
}

export interface ClassStudentInfo {
    id: number
    username: string
    full_name: string
    group_id: number | null
    status: AttendStatus
    connected?: boolean
    quizQuestion?: AssessmentAnswer[]
    isSubmitLecture?: boolean
    lectureQuestions?: AssessmentAnswer[]
    avatar?: string
    bonus_point: RewardPoint[]
}

export interface StudentChangeGroup {
    studentId: number
    username: string
    groupId: number | null
}

export enum ClassViewType {
    student = 'students',
    group = 'groups',
    leaderboard = 'leaderboard'
}
export const classViewTypeMap = {
    [ClassViewType.student]: TEXT.students,
    [ClassViewType.group]: TEXT.groups,
    [ClassViewType.leaderboard]: TEXT.leaderboard,
}

export enum AttendStatus {
    waiting = 'waiting',
    left = 'left',
    attended = 'attended',
    absent = 'absent'
}

export enum ClassViewMode {
    management = 'Management',
    teaching = 'Teaching'
}

export const classViewModeMap = {
    [ClassViewMode.management]: TEXT.management,
    [ClassViewMode.teaching]: TEXT.teaching
}
export interface PracticeQuizState {
    [Session.practice]?: boolean
    [Session.practice2]?: boolean
    [Session.quiz]?: boolean
}

export interface RankedGroup extends ClassGroupInfo {
    rank: number;
}

export interface RankedStudent extends ClassStudentInfo {
    rank: number;
}